module.exports = __webpack_public_path__ + "img/ícone-seta-direita-ultimo-azul.3738d17c.svg";